import type { Application, ApplicationMilestoneProgress, MilestoneItemProgress, MilestoneTemplate } from "../types";

/**
 * Every application gets one row per master milestone template, with item slots matching the template.
 * Preserves existing completion / bill links when template items still exist.
 */
export function syncMilestoneProgress(
  applications: Application[],
  templates: MilestoneTemplate[]
): Application[] {
  const sorted = [...templates].sort((a, b) => a.sortOrder - b.sortOrder);
  return applications.map((app) => {
    const existing = new Map(app.milestoneProgress.map((p) => [p.templateId, p]));
    const next: ApplicationMilestoneProgress[] = [];
    for (const t of sorted) {
      const prev = existing.get(t.id);
      const byItem = prev ? new Map(prev.itemProgress.map((ip) => [ip.templateItemId, ip])) : new Map();
      const itemProgress: MilestoneItemProgress[] = t.items.map((it) => {
        const old = byItem.get(it.id);
        return {
          templateItemId: it.id,
          completedAt: old?.completedAt ?? null,
          workDoneBillId: old?.workDoneBillId ?? null,
        };
      });
      next.push({
        templateId: t.id,
        itemProgress,
        milestoneCompletedAt: prev?.milestoneCompletedAt ?? null,
      });
    }
    return { ...app, milestoneProgress: next };
  });
}
